module.exports = __webpack_public_path__ + "static/11-638bace1f8c7ec290f66badf3ac6c805.jpg";